"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Reaction = function (props) {
    var count = props.count, emoji = props.emoji;
    return (preact_1.h("span", { className: "mt-[3px] mr-[3px] h-6 flex items-center justify-center text-xs font-semibold font-mono rounded-xl space-x-1 px-2 text-gray-800 border border-gray-200 dark:border-gray-700 transition bg-transparent" },
        preact_1.h("span", null, emoji),
        count && preact_1.h("span", null, count)));
};
exports.default = Reaction;
